<template>
    <i v-if="props.icon" :class="props.icon" />
</template>

<script setup lang="ts">
defineOptions({
    customOptions: {
        name: 'AxFileIcon',
    },
});
const props = defineProps({
    icon: {
        type: String,
        required: true,
    },
});
</script>
